module.exports = __webpack_public_path__ + "static/media/Slide16.978c19e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide16.png
// module id = 1638
// module chunks = 0